import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-baaa868c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "page-title pt-4" }, "Associer une marque à une catégorie URSSAF", -1))

import CustomButton from "@/components/forms/CustomButton.vue";
import PageMappingCategoryUrssafBrandEdition from "@/components/category/urssaf/MappingCategoryUrssafBrand.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PageMappingCategoryUrssafBrandEditionDetail',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomButton, {
      to: {
            name: 'ListUrssaf'
        },
      label: "Links.goBack"
    }),
    _hoisted_1,
    _createVNode(PageMappingCategoryUrssafBrandEdition)
  ], 64))
}
}

})